import React from 'react';
import {IconSVG} from "./IconSVG";

const IconButton = ({
                        icon,
                        variant = "primary",
                        clickHandler,
                        tintColor,
                        size, iconClass, ...rest
                    }: {
    icon: string, variant?: string, clickHandler: () => void, tintColor?: string, iconClass?: string
    size?: string, disabled?: boolean
}) => {
    return (
        <button type="button" className={`icon-btn btn btn-${variant}`} onClick={clickHandler} {...rest}>
            <IconSVG icon={icon} tintColor={tintColor} size={size} className={iconClass}/>
        </button>
    );
};

export default IconButton;
